import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import style from './style.module.scss';

const DRAWER_ROOT = 'drawer-root';
const drawerRoot = document.createElement('div');
drawerRoot.setAttribute('id', DRAWER_ROOT);
drawerRoot.setAttribute('class', style.reactDrawer);

/**
 * ReactDrawer.Component : Render the contents to be displayed in the
 * drawer.
 */
function Component(props) {
  React.useState(() => {
    document.body.appendChild(drawerRoot);

    return () => {
      document.body.removeChild(document.getElementById(DRAWER_ROOT));
    };
  }, []);

  const renderOverlay = () =>
    props.showOverlay ? <div className={style.reactDrawer_overlay} /> : null;

  if (props.visible) {
    return (
      <>
        {renderOverlay()}
        <div className={style.reactDrawer_content}>{props.children}</div>
      </>
    );
  } else return null;
}

Component.propTypes = {
  /**
   * Boolean specifying if the drawer is visible
   */
  visible: PropTypes.bool,
  /**
   * Boolean specifying if an overlay should be
   * displayed on the components lying below the drawer.
   */
  showOverlay: PropTypes.bool,
  /**
   * Child component to be displayed inside the drawer
   */
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element])
    .isRequired,
};

Component.defaultProps = {
  visible: false,
  showOverlay: true,
};

/**
 * ReactDrawer:
 *  - A custom drawer component
 */
export function ReactDrawer(props) {
  return ReactDOM.createPortal(
    React.createElement(
      Component,
      {visible: props.visible, showOverlay: props.showOverlay},
      props.children
    ),
    drawerRoot
  );
}

ReactDrawer.propTypes = {
  /**
   * Boolean specifying if the drawer is visible
   */
  visible: PropTypes.bool,
  /**
   * Boolean specifying if an overlay should be
   * displayed on the components lying below the drawer.
   */
  showOverlay: PropTypes.bool,
  /**
   * Child component to be displayed inside the drawer
   */
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element])
    .isRequired,
};

ReactDrawer.defaultProps = {
  visible: false,
  showOverlay: true,
};
